// Shared Tailwind class constants and the error-to-message hook for the
// Dienstplanung tab, which is split across AdminDienstplanungTab.tsx,
// PollSlotSection.tsx and PollParticipantSection.tsx. No JSX lives here, so
// this stays a .ts file.
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiClientError } from '../../lib/api';

export const DAY_MS = 86_400_000;

export const INPUT =
  'rounded-md border border-slate-300 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-100 px-3 py-2 text-sm';
export const BTN_PRIMARY =
  'rounded-md bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900 px-3 py-1.5 text-sm font-medium disabled:opacity-50';
export const BTN_SECONDARY =
  'rounded-md border border-slate-300 bg-white text-slate-700 dark:border-slate-600 dark:bg-slate-900 dark:text-slate-200 px-3 py-1.5 text-sm font-medium disabled:opacity-50';
export const BTN_DANGER =
  'rounded-md border border-rose-300 bg-white text-rose-700 dark:border-rose-700 dark:bg-slate-900 dark:text-rose-300 px-3 py-1.5 text-sm font-medium disabled:opacity-50';
export const BTN_ICON_DANGER =
  'rounded-md border border-rose-300 bg-white text-rose-700 dark:border-rose-700 dark:bg-slate-900 dark:text-rose-300 px-2 py-1 text-xs font-medium leading-none disabled:opacity-50';

/** Turn an unknown throw into a user-facing message, translating shared API
 *  error codes and falling back to the raw message. */
export function useErr() {
  const { t } = useTranslation();
  return useCallback(
    (e: unknown): string => {
      if (e instanceof ApiClientError) return t(`errors.${e.code}`, { defaultValue: e.message });
      return e instanceof Error ? e.message : String(e);
    },
    [t],
  );
}
